import { graphql, useStaticQuery } from "gatsby";

export const useLiveFlightInfoQuery = () => {
  const { allStrapiLiveFlightInfo } = useStaticQuery(graphql`
    query LiveFlightInfoQuery {
      allStrapiLiveFlightInfo {
        nodes {
          banner_section {
            desktop_bg {
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP])
                }
              }
            }
            mobile_bg {
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP])
                }
              }
            }
            heading
            text_color
            description {
              data {
                description
              }
            }
          }
          stay_informed {
            bg_color
            heading
            heading_color
            description {
              data {
                description
              }
            }
            description_color
          }
          disclaimer {
            description {
              data {
                description
              }
            }
            description_color
            heading
            heading_color
          }
          arrival_flight_icon {
            url
          }
          departure_icon {
            url
          }
          route_icon {
            url
          }
          arrow_icon {
            url
          }
          flight_facility_tabs {
            flight_type
            facilities_tabs {
              heading
              facility_cta {
                label
                label_color
                bg_color
                href
                icon {
                  alternativeText
                  url
                }
              }
            }
          }
        }
      }
    }
  `);
  return allStrapiLiveFlightInfo?.nodes[0];
};
